import styles from './home-card-separator.module.scss';

export function HomeCardSeparator() {
  return <div className={styles.separator}></div>;
}

export default HomeCardSeparator;
